<template>
  <div class="account_manage">
    <div class="account_manage_nav">
      <navbar
        title="账户管理"
        :lefticon="lefticon"
        :lefticonheight="1.8"
        :lefticonwidth="1.8"
        :fontweight="700"
        :fontsize="'1.8rem'"
        @goback="goBack(false)"
      />
    </div>
    <van-row class="box">
      <van-col span="24" class="manage">
        <div
          class="operationItem"
          v-for="(item, index) in accountList.list"
          :key="index"
        >
          <p class="name">{{ item.shop_name }}</p>
          <p class="identity" v-if="currentMemberId != item.member_id">
            <img
              src="../../../assets/purchaseSupplier/withdraw/customer_off.png"
              alt=""
            />客服员工
          </p>
          <p class="identity active" v-if="currentMemberId == item.member_id">
            <img
              src="../../../assets/purchaseSupplier/withdraw/customer_on.png"
              alt=""
            />客服员工
          </p>
          <!-- <p class="identity">
            <img
              src="../../../assets/purchaseSupplier/withdraw/staff_off.png"
              alt=""
            />集采供应方
          </p>
          <p class="identity active">
            <img
              src="../../../assets/purchaseSupplier/withdraw/staff_on.png"
              alt=""
            />集采供应方
          </p> -->
          <div class="account_msg">
            <img
              v-if="currentMemberId != item.member_id"
              @click="selectSingle(item)"
              src="@/assets/purchaseSupplier/common/no_select.png"
            />
            <img
              v-if="currentMemberId == item.member_id"
              @click="selectSingle(item)"
              src="@/assets/purchaseSupplier/withdraw/selected.png"
            />
          </div>
        </div>
        <!-- <div class="operationItem applyItem" @click="applySupplier">
          <img
            src="../../../assets/purchaseSupplier/withdraw/apply_supplier.png"
          />成为集采供应方
        </div> -->
      </van-col>
    </van-row>
    <van-row class="footer">
      <van-col span="24">
        <btn
          :btntext="'进入'"
          :btnwidth="'34.3rem'"
          :height="'4.4rem'"
          :bgcolor="'linear-gradient(to right, #fc740c, #f41a3c)'"
          :borderradius="'2.2rem'"
          :btncolor="'#fff'"
          :fontsize="'1.6rem'"
          @btnClick="switchIdentity"
        />
      </van-col>
    </van-row>
    <div class="loading" v-if="loading">
      <img src="../../../assets/common/loading.gif" />
    </div>
  </div>
</template>
<script>
import navbar from "../components/nav-bar.vue";
import btn from "../components/button.vue";
export default {
  components: {
    navbar,
    btn,
  },
  data() {
    return {
      accountList: [],
      loading: true,
      lefticon: require("@/assets/accountAgent/common/back.png"),
      currentMemberId: "",
    };
  },
  created() {
    this.currentMemberId = this.$route.query.member_id;
    this.getAccountInfo();
  },
  mounted() {
    document
      .querySelector(".box")
      .addEventListener("scroll", this.handleScroll);
    document.documentElement.style.setProperty(
      "font-size",
      (document.body.clientWidth / 375) * 10 + "px"
    );
  },
  methods: {
    async getAccountInfo() {
      // let bindStoreList = await this.$api.post("/store/member/get/store");
      // this.accountList = await this.$api.post(
      //   "/member-relation/member/three/year/supplier/supplier-list",
      //   {
      //     member_ids: bindStoreList.map((item) => {
      //       return item.member_id;
      //     }),
      //   }
      // );
      this.accountList = await this.$api.post(
        "/member-relation/member/three/year/supplier/supplier-list"
      );
      this.loading = false;
    },
    goBack() {
      this.$router.go(-1);
    },
    selectSingle(item) {
      this.currentMemberId = item.member_id;
    },
    switchIdentity() {
      sessionStorage.setItem("bindStoreId", this.currentMemberId);
      this.$router.go(-1);
    },
    // applySupplier() {},
  },
};
</script>
<style>
html {
  font-size: calc(var(--sizeScale2) * 10px);
}
</style>
<style lang="less" scoped>
.account_manage {
  height: 100%;
  box-sizing: border-box;
  background: #f5f6f7;

  .loading {
    text-align: center;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9999;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.7);
    img {
      width: 35%;
      margin-top: 65%;
    }
  }

  .account_manage_nav {
    position: fixed;
    top: 0;
    width: 100%;
    padding-top: 4.4rem;
    background-color: #fff;
    z-index: 3;
  }

  .box {
    box-sizing: border-box;
    height: 100%;
    padding: 8.8rem 0 7.5rem;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;

    .manage {
      background: #f5f6f7;
      padding: 0 1.6rem;
      min-height: calc(100% - 11.7rem);
      height: auto;
      box-sizing: border-box;
      position: relative;

      .operationItem {
        min-height: 8rem;
        border-radius: 0.8rem;
        background: #fff;
        margin-top: 1.2rem;
        padding: 1.6rem;
        box-sizing: border-box;

        .name {
          color: #333;
          font-size: 1.7rem;
          font-weight: 700;
          line-height: 2.4rem;
          margin-bottom: 0.4rem;
        }

        .identity {
          color: #999;
          font-size: 1.4rem;
          font-weight: 700;
          height: 2rem;
          line-height: 2rem;

          img {
            width: 1.4rem;
            float: left;
            margin: 0.3rem 0.7rem 0 0;
          }
        }

        .active {
          color: #fb6f0e;
        }

        .account_msg {
          float: right;
          margin-top: -3.5rem;

          img {
            width: 2rem;
          }

          // .num {
          //   color: #fff;
          //   font-size: 1.2rem;
          //   font-weight: 400;
          //   height: 2.1rem;
          //   line-height: 1.6rem;
          //   background: #ff3c3c;
          //   border-radius: 1rem;
          //   padding: 0 0.4rem;
          //   min-width: 1.5rem;
          //   text-align: center;
          //   box-sizing: border-box;
          //   display: inline-block;
          //   float: left;
          //   border: solid 0.3rem #ffcbcb;
          // }

          // .van-icon {
          //   width: 1.6rem;
          //   font-weight: 400;
          //   color: #999;
          //   margin: 0.5rem 0 0 1.2rem;
          // }
        }
      }

      // .applyItem {
      //   min-height: 5.4rem;
      //   line-height: 5.4rem;
      //   text-align: center;
      //   padding: 0;
      //   font-size: 1.4rem;
      //   color: #fb6f0e;
      //   font-weight: 700;

      //   img {
      //     width: 1.4rem;
      //     vertical-align: middle;
      //     margin-right: 0.7rem;
      //     margin-top: -0.4rem;
      //   }
      // }
    }
  }

  .footer {
    height: 6.2rem;
    padding: 0.4rem 1.6rem 0;
    background: #fff;
    box-sizing: border-box;
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
  }
}
</style>

